export default function ({ app }) {
  if (process.client) {
    window.addEventListener('error', (event) => {
      // Deteksi error ChunkLoadError
      const isChunkError = /Loading chunk [\d]+ failed/.test(event.message);
      
      if (isChunkError) {
        // Cek apakah kita sudah reload barusan (untuk mencegah loop)
        const reloadKey = 'nuxt-reload-chunk-error';
        const lastReload = sessionStorage.getItem(reloadKey);
        const timeNow = Date.now();

        // Jika belum pernah reload atau reload terakhir > 10 detik lalu
        if (!lastReload || timeNow - parseInt(lastReload) > 10000) {
           console.log('Chunk missing. Reloading...');
           sessionStorage.setItem(reloadKey, timeNow);
           event.preventDefault(); // Stop error muncul di console merah
           window.location.reload(true); // Force reload dari server
        }
      }
    });
  }
}
